import { TColumn } from '../../../columns/column.model';
import { createHeaderCellElement } from './create-header-cell-element';

export function createHeaderNameElement(
  _name: string,
  _width: string | number,
  _column: TColumn,
  _center: boolean = false,
): HTMLElement {
  return createHeaderCellElement({
    name: _name,
    center: _center,
    width: `${_width}px`,
    child: _name,
    column: _column,
    resize: true,
  });
}
